import React from 'react';
import { message } from 'antd';

import PaginationBase from '../../../common/base/PaginationBase';
import dialog from '../../../common/utility/dialog';
import estadoMock from '../../../common/mock/estadoMock';
import global from '../../../common/utility/global';

import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import { DOMICILIO_FISCAL } from '../../../common/types/tipoEstablecimientoType';
import { RUC } from '../../../common/types/tipoDocumentoType';
import { HABIDO } from '../../../common/types/condicionSunatType';
import { ACTIVO } from '../../../common/types/estadoContribuyenteType';
import { JURIFICA, NATURAL } from '../../../common/types/tipoPersonaType';

import clienteService from '../../../service/administracion/clienteService';
import padronReducidoService from '../../../service/integracion/padronReducidoService';
import tipoPersonaService from '../../../service/administracion/tipoPersonaService';
import tipoDocumentoService from '../../../service/administracion/tipoDocumentoService';
import condicionSunatService from '../../../service/administracion/condicionSunatService';
import estadoContribuyenteService from '../../../service/administracion/estadoContribuyenteService';
import tipoRelacionService from '../../../service/administracion/tipoRelacionService';
import vendedorService from '../../../service/administracion/vendedorService';
import tipoEstablecimientoService from '../../../service/administracion/tipoEstablecimientoService';
import establecimientoService from '../../../service/administracion/establecimientoService';
import ubigeoService from '../../../service/integracion/ubigeoService';
import paisService from '../../../service/administracion/paisService';
import vehiculoService from '../../../service/logistica/vehiculoService';

import contactoService from '../../../service/administracion/contactoService';


import Header from '../../../components/Header';
import Filters from './Filters';
import ResultList from './ResultList';
import FormModal from './FormModal';
import DetalleFormModal from './DetalleFormModal';
import EstablecimientoFormModal from '../Establecimiento/FormModal';

import VehiculoFormModal from './Vehiculo/VehiculoFormModal';
import VehiculoDetalle from './Vehiculo/VehiculoDetalle';
import ContactoFormModal from './Contacto/ContactoFormModal';
import ContactoDetalle from './Contacto/ContactoDetalle';
import CargaMasivaModal from './CargaMasivaModal';


export default class Index extends PaginationBase {
    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();
        this.state = {
            loadingSource: true,
            loadingExcel: false,
            loadingPdf: false,
            loadingPrint: false,
            visibleCargaMasiva: false,
            estados: estadoMock.values,
            tiposPersona: [],
            tiposDocumento: [],
            condicionesSunat: [],
            estadosContribuyente: [],
            tiposEstablecimiento: [],
            tiposRelacion: [],
            vendedores: [],
            departamentos: [],
            provincias: [],
            distritos: [],
            paises: [],
            filter: {
                idTipoPersona: 0,
                idTipoDocumento: 0,
                numeroDocumento: '',
                nombreRazonSocial: '',
                idVendedor: 0,
                ...FILTER
            },
            pagination: PAGINATION,
            visible: false,
            visibleDetalle: false,
            visibleVehiculo: false,
            visibleDetalleContacto: false,

            visibleFormEstablecimiento: false,
            visibleFormVehiculo: false,
            visibleFormContacto: false,
            formValues: this.fetchEmptyFormValues(),
            formValuesDetalle: this.fetchEmptyFormValuesDetalle(),
            formValuesEstablecimiento: this.fetchEmptyFormValuesEstablecimiento(),
            formValuesVehiculo: this.fetchEmptyFormValuesVehiculo(),
            formValuesContacto: this.fetchEmptyFormValuesContacto(),
            formValuesDetalleContacto: this.fetchEmptyFormValuesDetalleContacto(),

        }
    }

    handleClearFilters = () => {
        var filter = {
            idTipoPersona: 0,
            idTipoDocumento: 0,
            numeroDocumento: '',
            nombreRazonSocial: '',
            ...FILTER
        };
        this.setState({ filter });
        this._handlePagination(filter);
    };

    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter, ...FILTER };
            this._handlePagination(filter);
        }
    };

    handleChange = (property, value) => {
        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter });
    };

    handleExportExcel = async () => {
        this.setState({ loadingExcel: true });
        var response = await clienteService.excel(this.state.filter);
        this.setState({ loadingExcel: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Cliente.xlsx");
    };

    handleExportPdf = async () => {
        this.setState({ loadingPdf: true });
        var response = await clienteService.pdf(this.state.filter);
        this.setState({ loadingPdf: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Cliente.pdf");
    }

    handlePrint = async () => {
        this.setState({ loadingPrint: true });
        var response = await clienteService.pdf(this.state.filter);
        this.setState({ loadingPrint: false });
        if (response !== undefined) {
            var file = window.URL.createObjectURL(response.data);
            var win = window.open(file, '_blank');
            win.focus();
        }
    }

    handleDeleteActive = (values) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;
            if (values.flag)
                response = await clienteService.eliminar(values);
            else
                response = await clienteService.activar(values);

            if (response.status === 200) {
                message.success('Proceso realizado correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    /******************** FORM MODAL *****************/

    fetchEmptyFormValues = () => {
        return {
            id: 0,
            idTipoPersona: 0,
            idTipoDocumento: RUC.ID,
            numeroDocumento: '',
            razonSocial: '',
            nombre: '',
            apellidoPaterno: '',
            apellidoMaterno: '',
            correo: '',
            contacto: '',
            idEstadoContribuyente: ACTIVO,
            idCondicionSunat: HABIDO,
            idTipoRelacion: 0,
            idVendedor: 0,
            nombreTipoEstablecimiento: '',
            telefono: '',
            idDepartamento: 0,
            idProvincia: 0,
            idUbigeo: 0,
            idPais: 0,
            direccion: '',
            /******************/
            searchLoading: false,
            flagPersonaJuridica: true,
            flagPersonaNatural: false,
            tiposPersona: [],
            tiposDocumento: [],
            condicionesSunat: [],
            estadosContribuyente: [],
            tiposEstablecimiento: [],
            tiposRelacion: [],
            vendedores: [],
            departamentos: [],
            provincias: [],
            distritos: [],
            paises: [],
        }
    };

    fetchEmptyFormValuesDetalle = () => {
        return {
            idEntidad: 0,
            nombre: '',
            detalle: []
        }
    };

    fetchEmptyFormValuesDetalleVehiculo = () => {
        return {
            idEntidad: 0,
            nombre: '',
            detalle: []
        }
    };

    fetchEmptyFormValuesDetalleContacto = () => {
        return {
            idEntidad: 0,
            nombre: '',
            detalle: []
        }
    };

    fetchEmptyFormValuesEstablecimiento = () => {
        return {
            id: 0,
            nombre: '',
            idTipoEstablecimiento: 0,
            idDepartamento: 0,
            idProvincia: 0,
            idUbigeo: 0,
            direccion: '',
            telefono: '',
            tipoEstablecimientos: [],
            departamentos: [],
            provincias: [],
            distritos: []
        }
    };

    fetchEmptyFormValuesVehiculo = () => {
        return {
            id: 0,
            color: '',
            marca: '',
            modelo: '',
            placa: '',
            idCliente: 0,
            cliente: '',
        }
    };

    fetchEmptyFormValuesContacto = () => {
        return {
            id: 0,
            nombre: '',
            direccion: '',
            telefono: '',
            correo: '',
            idCliente: 0,
            cliente: '',
            flagPrincipal: false
        }
    };


    handleNew = () => {
        var formValues = this.fetchEmptyFormValues();
        var tipoEstablecimientoFiltered = this.state.tiposEstablecimiento.filter(m => m.id === DOMICILIO_FISCAL.ID);
        var tiposPersonaFiltered = this.state.tiposPersona.filter(m => m.codigo === JURIFICA.CODIGO);

        formValues.tiposPersona = this.state.tiposPersona;
        formValues.paises = this.state.paises;
        formValues.tiposDocumento = this.state.tiposDocumento;
        formValues.condicionesSunat = this.state.condicionesSunat;
        formValues.estadosContribuyente = this.state.estadosContribuyente;
        formValues.tiposRelacion = this.state.tiposRelacion;
        formValues.vendedores = this.state.vendedores;
        formValues.contacto = this.state.contacto;
        formValues.departamentos = this.state.departamentos;
        formValues.idTipoPersona = tiposPersonaFiltered.length === 0 ? 0 : tiposPersonaFiltered[0].id
        formValues.nombreTipoEstablecimiento = tipoEstablecimientoFiltered.length === 0 ? '' : tipoEstablecimientoFiltered[0].nombre;

        this.setState({ visible: true, formValues });
    };

    /*     handleViewContacto = async (row) => {
            var formValuesDetalle = this.fetchEmptyFormValuesDetalleContacto();
            var detalle = await contactoService.listarPorIdCliente(row.id);
    
            formValuesDetalle.idEntidad = row.idEntidad;
            formValuesDetalle.detalle = detalle;
    
            this.setState({
                visibleFormContacto: true,
                detalle,
                formValuesDetalle,
                formValuesContacto: {
                    ...this.state.formValuesContacto,
                    cliente: row.nombreRazonSocial,
                    idCliente: row.id
                }
            });
        }; */


    handleViewDetalle = async (row) => {
        var formValuesDetalle = this.fetchEmptyFormValuesDetalle();
        var detalle = await establecimientoService.listarTodoPorIdEntidad(row.idEntidad);

        formValuesDetalle.idEntidad = row.idEntidad;
        formValuesDetalle.detalle = detalle;

        this.setState({
            visibleDetalle: true,
            detalle,
            formValuesDetalle,

        });
    };

    handleViewDetalleContacto = async (row) => {

        var formValuesDetalleContacto = this.fetchEmptyFormValuesDetalleContacto();
        var detalle = await contactoService.listarPorIdCliente(row.id);

        formValuesDetalleContacto.idEntidad = row.idEntidad;
        formValuesDetalleContacto.detalle = detalle;

        this.setState({
            visibleDetalleContacto: true,
            detalle,
            formValuesDetalleContacto,
            formValuesContacto: {
                ...this.state.formValuesContacto,
                cliente: row.nombreRazonSocial,
                idCliente: row.id
            }
        });
    };


    handleViewVehiculo = async (row) => {
        var formValuesDetalle = this.fetchEmptyFormValuesDetalleVehiculo();
        var detalle = await vehiculoService.obtenerPorClienteId(row.id);

        formValuesDetalle.idEntidad = row.idEntidad;
        formValuesDetalle.detalle = detalle;

        this.setState({
            visibleVehiculo: true,
            detalle,
            formValuesDetalle,
            formValuesVehiculo: {
                ...this.state.formValuesVehiculo,
                cliente: row.nombreRazonSocial,
                idCliente: row.id
            }
        });
    };


    handleNewEstablecimiento = () => {
        var formValuesEstablecimiento = this.fetchEmptyFormValuesEstablecimiento();
        formValuesEstablecimiento.tipoEstablecimientos = this.state.tiposEstablecimiento.filter(m => { return m.codigoSunat !== DOMICILIO_FISCAL.CODIGO });
        formValuesEstablecimiento.departamentos = this.state.departamentos;
        this.setState({ visibleFormEstablecimiento: true, formValuesEstablecimiento });
    };


    handleNewContacto = () => {

        var idCliente = this.state.formValuesContacto.idCliente;

        var formValuesContacto = this.fetchEmptyFormValuesContacto();
        formValuesContacto.idCliente = idCliente;

        this.setState({ visibleFormContacto: true, formValuesContacto });
    };


    handleNewVehiculo = () => {
        var cliente = this.state.formValuesVehiculo.cliente;
        var idCliente = this.state.formValuesVehiculo.idCliente;

        var formValuesVehiculo = this.fetchEmptyFormValuesVehiculo();
        formValuesVehiculo.cliente = cliente;
        formValuesVehiculo.idCliente = idCliente;

        this.setState({ visibleFormVehiculo: true, formValuesVehiculo });
    };

    hanleBuscarEstablecimiento = async (value) => {
        const detalleFiltered = this.state.detalle.filter(m => ['', null, undefined].includes(value) ||
            global.formatSearch(m.nombre).match(global.formatSearch(value)));

        this.setState({
            formValuesDetalle: {
                ...this.state.formValuesDetalle,
                detalle: detalleFiltered
            }
        });
    };

    hanleBuscarVehiculo = async (value) => {
        const detalleFiltered = this.state.detalle.filter(m => ['', null, undefined].includes(value) ||
            global.formatSearch(m.placa).match(global.formatSearch(value)));

        this.setState({
            formValuesDetalle: {
                ...this.state.formValuesDetalle,
                detalle: detalleFiltered
            }
        });
    };

    handleBuscarPadronReducido = async (idTipoDocumento, numeroDocumento, form) => {
        this.setState({ formValues: { ...this.state.formValues, searchLoading: true } });
        const response = await padronReducidoService.entidad({ idTipoDocumento, numeroDocumento });
        if (response.status === 200) {
            const provincias = await ubigeoService.provincias(response.data.idDepartamento);
            const distritos = await ubigeoService.distritos(response.data.idProvincia);
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    searchLoading: false,
                    provincias,
                    distritos
                }
            }, () => {
                form.setFieldsValue({
                    razonSocial: response.data.razonSocial,
                    nombre: response.data.nombre,
                    apellidoMaterno: response.data.apellidoMaterno,
                    apellidoPaterno: response.data.apellidoPaterno,
                    idCondicionSunat: { key: response.data.idCondicionSunat },
                    idEstadoContribuyente: { key: response.data.idEstadoContribuyente },
                    idDepartamento: { key: response.data.idDepartamento !== 0 ? response.data.idDepartamento : undefined },
                    idProvincia: { key: response.data.idProvincia !== 0 ? response.data.idProvincia : undefined },
                    idUbigeo: { key: response.data.idUbigeo !== 0 ? response.data.idUbigeo : undefined },
                    direccion: response.data.direccion,
                });
            });
        }
        else {
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    searchLoading: false
                }
            });
        }
    };

    handleEdit = async (values) => {
        const response = await clienteService.obtenerPorId(values.id);

        const paises = await paisService.getBySearch({
            id: response.idPais,
            value: ''
        });
        if (response !== undefined) {
            response.flagPersonaJuridica = response.codigoTipoPersona === JURIFICA.CODIGO ? true : false;
            response.flagPersonaNatural = response.codigoTipoPersona === NATURAL.CODIGO ? true : false;
            response.paises = paises;
            response.tiposPersona = this.state.tiposPersona;
            response.tiposDocumento = this.state.tiposDocumento;
            response.condicionesSunat = this.state.condicionesSunat;
            response.estadosContribuyente = this.state.estadosContribuyente;
            response.tiposRelacion = this.state.tiposRelacion;
            response.vendedores = this.state.vendedores;
            response.contacto = response.contacto;

            response.departamentos = this.state.departamentos;
            response.provincias = await ubigeoService.provincias(response.idDepartamento);
            response.distritos = await ubigeoService.distritos(response.idProvincia);
            this.setState({ visible: true, formValues: response });
        }
    };

    handleEditEstablecimiento = async (values) => {
        const response = await establecimientoService.obtenerPorId(values.id);
        if (response !== undefined) {
            response.tipoEstablecimientos = this.state.tiposEstablecimiento.filter(m => { return m.codigoSunat !== DOMICILIO_FISCAL.CODIGO });
            response.departamentos = this.state.departamentos;
            response.provincias = await ubigeoService.provincias(response.idDepartamento);
            response.distritos = await ubigeoService.distritos(response.idProvincia);
            this.setState({ visibleFormEstablecimiento: true, formValuesEstablecimiento: response });
        }
    };


    handleEditVehiculo = async (values) => {
        var cliente = this.state.formValuesVehiculo.cliente;
        values.cliente = cliente;

        this.setState({ visibleFormVehiculo: true, formValuesVehiculo: values });

    };

    handleChangeForm = async (property, value) => {
        if (property === "idDepartamento") {
            const provincias = await ubigeoService.provincias(value);
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    provincias: provincias ? provincias : [],
                    distritos: []
                }
            });
        }

        if (property === "idProvincia") {
            const distritos = await ubigeoService.distritos(value);
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    distritos: distritos ? distritos : []
                }
            });
        }


        if (property === "clear") {
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    provincias: [],
                    distritos: []
                }
            });
        }
    };

    handleChangeFormEstablecimiento = async (property, value) => {
        if (property === "idDepartamento") {
            const provincias = await ubigeoService.provincias(value);
            this.setState({
                formValuesEstablecimiento: {
                    ...this.state.formValuesEstablecimiento,
                    provincias: provincias ? provincias : [],
                    distritos: []
                }
            });
        }

        if (property === "idProvincia") {
            const distritos = await ubigeoService.distritos(value);
            this.setState({
                formValuesEstablecimiento: {
                    ...this.state.formValuesEstablecimiento,
                    distritos: distritos ? distritos : []
                }
            });
        }
    };

    handleSave = (values, form) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;

            if (values.id === 0)
                response = await clienteService.registrar(values);
            else
                response = await clienteService.modificar(values);

            if (response.status === 200) {
                form.resetFields();
                this.setState({ visible: false });
                message.success((values.id === 0 ? 'Registrado' : 'Modificado') + ' correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    handleSaveEstablecimiento = (values, form) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            values.idEntidad = this.state.formValuesDetalle.idEntidad;
            var response;
            if (values.id === 0)
                response = await establecimientoService.registrar(values);
            else
                response = await establecimientoService.modificar(values);

            if (response.status === 200) {
                var detalle = await establecimientoService.listarTodoPorIdEntidad(values.idEntidad);

                form.resetFields();
                this.setState({
                    detalle,
                    visibleFormEstablecimiento: false
                }, () => this.hanleBuscarEstablecimiento(''));

                message.success((values.id === 0 ? 'Registrado' : 'Modificado') + ' correctamente.');
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li key={global.fetchUniqueCode()}>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };



    handleSaveVehiculo = (values, form) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;

            if (values.id === 0)
                response = await vehiculoService.registrar(values);
            else
                response = await vehiculoService.modificar(values);

            if (response.status === 200) {
                var cliente = this.state.formValuesVehiculo.cliente;

                var empty = this.fetchEmptyFormValuesVehiculo();
                form.setFieldsValue(empty);
                empty.cliente = cliente;
                empty.idCliente = values.idCliente;

                this.setState({ visibleFormVehiculo: false, formValuesVehiculo: empty });
                var detalle = await vehiculoService.obtenerPorClienteId(values.idCliente);

                form.resetFields();
                this.setState({
                    detalle,
                    visibleFormVehiculo: false
                }, () => this.hanleBuscarVehiculo(''));

                if (values.id === 0)
                    message.success('Registrado correctamente.');
                else
                    message.success('Modificado correctamente.');

                return;
            }
            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }
            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };


    handleDeleteActiveEstablecimiento = (values) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;
            if (values.flag)
                response = await establecimientoService.eliminar(values);
            else
                response = await establecimientoService.activar(values);

            if (response.status === 200) {
                var detalle = await establecimientoService.listarTodoPorIdEntidad(this.state.formValuesDetalle.idEntidad);
                this.setState({ detalle }, () => this.hanleBuscarEstablecimiento(''));
                message.success('Proceso realizado correctamente.');
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    handleDeleteActiveVehiculo = (values) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;
            if (values.flag)
                response = await vehiculoService.eliminar(values);
            else
                response = await vehiculoService.activar(values);

            if (response.status === 200) {
                var detalle = await vehiculoService.obtenerPorClienteId(values.idCliente);

                this.setState({ detalle }, () => this.hanleBuscarVehiculo(''));
                message.success('Proceso realizado correctamente.');
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };



    handleSaveContacto = (values, form) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;

            if (values.id === 0)
                response = await contactoService.registrar(values);
            else
                response = await contactoService.modificar(values);

            if (response.status === 200) {

                var formValuesDetalleContacto = this.fetchEmptyFormValuesDetalleContacto();
                var detalle = await contactoService.listarPorIdCliente(this.state.formValuesContacto.idCliente);
                formValuesDetalleContacto.detalle = detalle;

                this.setState({
                    visibleFormContacto: false,
                    detalle,
                    formValuesDetalleContacto
                });

                if (values.id === 0)
                    message.success('Registrado correctamente.');
                else
                    message.success('Modificado correctamente.');

                return;
            }
            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }
            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    handleDeleteActiveContacto = (values) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;
            if (values.flag)
                response = await contactoService.eliminar(values);
            else
                response = await contactoService.activar(values);

            if (response.status === 200) {

                var formValuesDetalleContacto = this.fetchEmptyFormValuesDetalleContacto();
                var detalle = await contactoService.listarPorIdCliente(this.state.formValuesContacto.idCliente);
                formValuesDetalleContacto.detalle = detalle;

                this.setState({
                    detalle,
                    formValuesDetalleContacto
                });

                message.success('Proceso realizado correctamente.');
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    handleEditContacto = async (values) => {

        var idCliente = this.state.formValuesContacto.idCliente;
        var formValuesContacto = this.fetchEmptyFormValuesContacto();
        formValuesContacto.idCliente = idCliente;
        formValuesContacto.cliente = values.cliente;
        formValuesContacto.correo = values.correo;
        formValuesContacto.direccion = values.direccion;
        formValuesContacto.flag = values.flag;
        formValuesContacto.id = values.id;
        formValuesContacto.nombre = values.nombre;
        formValuesContacto.telefono = values.telefono;
        this.setState({ visibleFormContacto: true, formValuesContacto });

    };


    hanleBuscarContacto = async (value) => {
        const detalleFiltered = this.state.detalle.filter(m => ['', null, undefined].includes(value) ||
            global.formatSearch(m.nombre).match(global.formatSearch(value)));

        this.setState({
            formValuesDetalleContacto: {
                ...this.state.formValuesDetalleContacto,
                detalle: detalleFiltered
            }
        });
    };


    handleNewCargaMasiva = () => {
        this.setState({ visibleCargaMasiva: true });
    };

    handleDownloadFormatoCargaMasiva = async () => {
        var response = await clienteService.formatoCargaMasiva();
        if (response !== undefined)
            global.dowloadFile(response.data, "template-carga-masiva-producto.xlsx");
    };

    handleSaveCargaMasiva = async (values, form) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;

            response = await clienteService.registrarCargaMasiva(values);

            if (response.status === 200) {
                var empty = this.fetchEmptyFormValues();
                this.setState({ visibleCargaMasiva: false, formValues: empty });
                form.setFieldsValue(empty);
                form.resetFields();

                message.success('Registrado correctamente.');

                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li key={global.fetchUniqueCode()}>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };


    searchTimeout = null;

    handleSearchPaises = (value, form) => {
        // Limpiar timeout anterior
        clearTimeout(this.searchTimeout);

        // No buscar si está vacío o tiene menos de 3 caracteres
        if (!value || value.trim().length < 3) {
            return;
        }

        this.searchTimeout = setTimeout(async () => {
            this.setState({ fetching: true });

            try {
                const response = await paisService.getBySearch({
                    id: 0,
                    value: value
                });

                if (response) {
                    form.setFieldsValue({
                        paises: response,
                    });
                }
            } finally {
                this.setState({ fetching: false });
            }
        }, 500); // Espera 500 ms después de la última tecla
    };



    async componentDidMount() {
        this._initPagination(this.state.filter, clienteService.paginacion);

        const tiposPersona = await tipoPersonaService.listar();
        const tiposDocumento = await tipoDocumentoService.listarExcluirPlaca();
        const condicionesSunat = await condicionSunatService.listar();
        const estadosContribuyente = await estadoContribuyenteService.listar();
        const departamentos = await ubigeoService.departamentos();
        const tiposRelacion = await tipoRelacionService.listar();
        const vendedores = await vendedorService.listar();
        const tiposEstablecimiento = await tipoEstablecimientoService.listar();
        const paises = [];// await paisService.listar();


        this.setState({
            loadingSource: false,
            tiposPersona: tiposPersona ? tiposPersona : [],
            tiposDocumento: tiposDocumento ? tiposDocumento : [],
            condicionesSunat: condicionesSunat ? condicionesSunat : [],
            estadosContribuyente: estadosContribuyente ? estadosContribuyente : [],
            tiposRelacion: tiposRelacion ? tiposRelacion : [],
            vendedores: vendedores ? vendedores : [],
            departamentos: departamentos ? departamentos : [],
            tiposEstablecimiento: tiposEstablecimiento ? tiposEstablecimiento : [],
            paises: paises ? paises : [],
        });
    };

    render() {
        return (
            <div>
                <Header
                    title="Cliente"
                    onNew={this.handleNew}
                    loadingNew={this.state.loadingSource}
                    onSearch={() => this._handlePagination({ ...this.state.filter, ...FILTER })}
                    onClearFilters={this.handleClearFilters}

                    onNewCargaMasiva={this.handleNewCargaMasiva}
                    loadingNewCargaMasiva={this.state.loadingSource}
                />
                <Filters
                    filter={this.state.filter}
                    tiposPersona={this.state.tiposPersona}
                    tiposDocumento={this.state.tiposDocumento}
                    estados={this.state.estados}
                    vendedores={this.state.vendedores}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}
                />
                <ResultList
                    pagination={this.state.pagination}
                    loadingEdit={this.state.loadingSource}
                    loadingExcel={this.state.loadingExcel}
                    loadingPdf={this.state.loadingPdf}
                    loadingPrint={this.state.loadingPrint}
                    onExportExcel={this.handleExportExcel}
                    onExportPdf={this.handleExportPdf}
                    onPrint={this.handlePrint}
                    onEdit={this.handleEdit}
                    onViewVehiculo={this.handleViewVehiculo}
                    onViewContacto={this.handleViewDetalleContacto}

                    onViewDetail={this.handleViewDetalle}
                    onDeleteActive={this.handleDeleteActive}
                    onChange={this._handleChangePagination}
                />
                <FormModal
                    visible={this.state.visible}
                    formValues={this.state.formValues}
                    onChange={this.handleChangeForm}
                    onBuscarPadronReducido={this.handleBuscarPadronReducido}
                    onClose={() => this.setState({ visible: false })}
                    onSave={this.handleSave}

                    fetchPaises={this.handleSearchPaises}
                    fetching={this.state.fetching}
                />
                <DetalleFormModal
                    visible={this.state.visibleDetalle}
                    formValues={this.state.formValuesDetalle}
                    onSearch={this.hanleBuscarEstablecimiento}
                    onClose={() => this.setState({ visibleDetalle: false })}
                    onNew={this.handleNewEstablecimiento}
                    onEdit={this.handleEditEstablecimiento}
                    onDeleteActive={this.handleDeleteActiveEstablecimiento}
                />
                <EstablecimientoFormModal
                    visible={this.state.visibleFormEstablecimiento}
                    formValues={this.state.formValuesEstablecimiento}
                    onChange={this.handleChangeFormEstablecimiento}
                    onClose={() => this.setState({ visibleFormEstablecimiento: false })}
                    onSave={this.handleSaveEstablecimiento}
                />

                <VehiculoDetalle
                    visible={this.state.visibleVehiculo}
                    formValues={this.state.formValuesDetalle}
                    onSearch={this.hanleBuscarVehiculo}
                    onClose={() => this.setState({ visibleVehiculo: false })}
                    onNew={this.handleNewVehiculo}
                    onEdit={this.handleEditVehiculo}
                    onDeleteActive={this.handleDeleteActiveVehiculo}
                />

                <VehiculoFormModal
                    visible={this.state.visibleFormVehiculo}
                    formValues={this.state.formValuesVehiculo}
                    onClose={() => this.setState({ visibleFormVehiculo: false })}
                    onSave={this.handleSaveVehiculo}
                />

                <ContactoFormModal
                    visible={this.state.visibleFormContacto}
                    formValues={this.state.formValuesContacto}
                    onClose={() => this.setState({ visibleFormContacto: false })}
                    onSave={this.handleSaveContacto}
                />

                <ContactoDetalle
                    visible={this.state.visibleDetalleContacto}
                    formValues={this.state.formValuesDetalleContacto}
                    onSearch={this.hanleBuscarContacto}
                    onClose={() => this.setState({ visibleDetalleContacto: false })}
                    onNew={this.handleNewContacto}
                    onEdit={this.handleEditContacto}
                    onDeleteActive={this.handleDeleteActiveContacto}
                />

                <CargaMasivaModal
                    onDownloadFormatoCargaMasiva={this.handleDownloadFormatoCargaMasiva}
                    visible={this.state.visibleCargaMasiva}
                    formValues={this.state.formValues}
                    onUploadFile={clienteService.subirCargaMasiva}
                    onClose={() => this.setState({ visibleCargaMasiva: false })}
                    onSave={this.handleSaveCargaMasiva}
                />
            </div>
        )
    }
}